import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, SectionHeading } from "@/components/Shared";
import { POSTS } from "@/posts";

export const InsightsSection = () => (
  <section className="py-20 sm:py-28 border-t border-[#F0EBF8]" data-testid="insights-section">
    <div className="max-w-6xl mx-auto px-6">
      <SectionHeading
        eyebrow="Insights"
        title="Notes for recruitment founders."
        sub="Short, practical writing on building a client pipeline that doesn't depend on luck."
      />
      <div className="mt-12 max-w-3xl mx-auto">
        {POSTS.map((post) => (
          <Reveal key={post.slug}>
            <Link
              to={`/insights/${post.slug}`}
              data-testid={`insight-card-${post.slug}`}
              className="group block rounded-3xl border border-[#E9E4F0] bg-[#EDEDF1] p-8 sm:p-10 transition-colors duration-300 hover:border-violet-300"
            >
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#6B5CA5]">
                {post.date} · {post.readTime}
              </p>
              <h3 className="font-display mt-3 text-2xl sm:text-3xl font-bold tracking-tight text-[#3B0764] transition-colors duration-300 group-hover:text-violet-700">
                {post.title}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-[#6B5CA5]">{post.excerpt}</p>
              <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-violet-700">
                Read the post
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
